import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

export interface State {
  showSb: boolean,
  width:number | null,
  scrollHeight:number | null
}

const defaultState: State = {
  showSb: false,
  width:null,
  scrollHeight:0
}

const getters = {
  GetScrollHeight(state:State){
    return state.scrollHeight
  },
  GetShowSb (state: State):Boolean{
    return  state.showSb
  },
  GetWidth(state:State){
    return state.width
  }
}

const mutations: MutationTree<State> = {
  setScrollHeight(state:State,payload:number | null):any{
    state.scrollHeight = payload
  },
  SetShowSb(state:State, payload:boolean):void{
    state.showSb = payload
  },
  SetShowSbToggle(state:State,payload):void{
    state.showSb = payload
  },
  SetWidth(state:State,payload:number|null):void{
    state.width = payload
  }
}

const actions: ActionTree<State, RootState> = {}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
